import { List } from './list/list.component';
import Belly from './belly/belly.component';
import Solo from './solo/solo.component';
import SlideShow from './slideShow/slideShow.component';
import Grid from './grid/grid.component';
import Epg from './epg/epg.component';

export const blockFallback = List.Templates.List;

export const blockTemplates = {
  [List.Templates.List]: List,
  [Belly.Templates.Belly]: Belly,
  [Solo.Templates.Solo]: Solo,
  [SlideShow.Templates.SlideShow]: SlideShow,
  [Grid.Templates.Grid]: Grid,
  [Epg.Templates.HorizontalEpg]: Epg,
};

export const getBlockTemplateById = id => blockTemplates[id] || blockTemplates[blockFallback];
